/** @jsx h */
/** @jsxFrag Fragment */
import { type ComponentChildren, h } from "preact";
import { cx } from "@utils/utils";

export interface DatRowProps {
  label: string;
  children: ComponentChildren;
}
export function DatRow(props: DatRowProps) {
  return (
    <li class="cr dat-row">
      <label>
        <span class="label-text">{props.label}</span>
        <span class="dat-row-items">{props.children}</span>
      </label>
    </li>
  );
}

export interface RowButtonProps {
  active?: boolean;
  onClick: () => void;
  children: ComponentChildren;
}
export function RowButton(props: RowButtonProps) {
  return (
    <span
      role="button"
      tabIndex={0}
      class={cx("row-button", props.active && "active")}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") props.onClick();
      }}
    >
      {props.children}
    </span>
  );
}
